import React from 'react';
import { ProdutoContent } from '~/pages/Produto/ProdutoContent';
import { ProdutoContextProvider } from './ProdutoContext';

export const Produto: React.FC = () => {
  return (
    <ProdutoContextProvider>
      <ProdutoContent />
    </ProdutoContextProvider>
  );
};
